module.exports = {
	"id": "AT",
	"name": "Austria",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.019716,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": 0.059148,
			"23": null,
			"24": null,
			"25": null,
			"26": 0.026288,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": 0.092008,
			"32": 0.006572,
			"33": 0.013144,
			"34": 0.039432,
			"35": 0.013144,
			"36": 0.019716,
			"37": 0.019716,
			"38": 0.03286,
			"39": 0.03286,
			"40": 0.019716,
			"41": 0.026288,
			"42": 0.019716,
			"43": 0.06572,
			"44": 0.046004,
			"45": 0.072292,
			"46": 0.059148,
			"47": 0.059148,
			"48": 0.092008,
			"49": 0.9858,
			"50": 0.092008,
			"51": 0.42718,
			"52": 0.433752,
			"53": 16.962332,
			"54": 4.23894,
			"55": 0.052576,
			"56": 0.019716,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.006572,
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": 0.013144,
			"11": null,
			"12": 0.039432,
			"13": null,
			"14": 0.006572,
			"15": null,
			"16": 0.019716,
			"17": null,
			"18": null,
			"19": null,
			"20": 0.019716,
			"21": null,
			"22": null,
			"23": null,
			"24": 0.006572,
			"25": 0.006572,
			"26": 0.013144,
			"27": null,
			"28": 0.013144,
			"29": 0.013144,
			"30": 0.019716,
			"31": 0.046004,
			"32": 0.026288,
			"33": 0.026288,
			"34": 0.03286,
			"35": 0.03286,
			"36": 0.046004,
			"37": 0.03286,
			"38": 0.203732,
			"39": 0.085436,
			"40": 0.059148,
			"41": 0.092008,
			"42": 0.138012,
			"43": 0.190588,
			"44": 0.092008,
			"45": 0.414036,
			"46": 0.13144,
			"47": 0.992372,
			"48": 1.08438,
			"49": 14.09694,
			"50": 0.09858,
			"51": 0.013144,
			"52": 0.013144,
			"3.5": null,
			"3.6": 0.026288
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": 0.013144,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": 0.006572,
			"36": 0.039432,
			"37": 0.039432,
			"38": 0.046004,
			"39": 0.085436,
			"40": 0.88722,
			"41": 0.151156,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.138012
		},
		"safari": {
			"0": null,
			"4": 0.013144,
			"5": 0.059148,
			"6": 0.013144,
			"7": 0.052576,
			"8": 0.289168,
			"9": 0.414036,
			"10": 2.405352,
			"3.1": null,
			"3.2": null,
			"5.1": 0.236592,
			"6.1": 0.13144,
			"7.1": 0.026288,
			"9.1": 1.623284
		},
		"ios_saf": {
			"8": 0,
			"10": 7.28766426395,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.196394119172,
			"8.1-8.4": 0.362829813385,
			"9.0-9.2": 0.173093121982,
			"9.3": 2.64077968152
		},
		"android": {
			"3": 0,
			"4": 0.0310736511628,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00388420639535,
			"4.1": 0.112087098837,
			"4.2-4.3": 0.280217747093,
			"4.4": 0.642558715116,
			"4.4.3-4.4.4": 0.648107581395
		},
		"ie": {
			"6": null,
			"7": 0.0197412931366,
			"8": 0.243475948685,
			"9": 0.30928025914,
			"10": 0.315860690186,
			"11": 9.37053380885,
			"5.5": null
		},
		"op_mob": {
			"0": 0.0104048080623,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.000289022446175
		},
		"edge": {
			"12": 0.144584,
			"13": 0.946368,
			"14": 2.76024
		},
		"ie_mob": {
			"10": 0.0851937464789,
			"11": 0.346860253521
		},
		"bb": {
			"7": 0.017145,
			"10": null
		},
		"samsung": {
			"0": 5.28066
		},
		"and_uc": {
			"0": 0.106299
		},
		"op_mini": {
			"0": 0.140182169492
		},
		"and_chr": {
			"0": 16.569461
		},
		"and_ff": {
			"0": 0.065151
		}
	},
	"total": 97.979812
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/AT.json
 ** module id = 466
 ** module chunks = 0
 **/